function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { AnimationWrapper } from "./AnimationWrapper";
import { CloseButton } from "./CloseButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var Tooltip = function Tooltip(_ref) {
  var isOpen = _ref.isOpen,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "top" : _ref$placement,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "dt_taro90" : _ref$color,
    onDismiss = _ref.onDismiss,
    _ref$animate = _ref.animate,
    animate = _ref$animate === void 0 ? false : _ref$animate,
    maxWidth = _ref.maxWidth,
    children = _ref.children;
  var weight = color.slice(-2);
  var triangleStyle = {
    content: '" "',
    position: "absolute",
    width: "15px",
    height: "15px",
    backgroundColor: color
  };
  var placementStyles = {
    top: {
      bottom: "0",
      left: "50%",
      borderRadius: RAW_cssValue("0 0 5px"),
      transform: "translate(-50%, 50%) rotate(45deg) skew(7deg, 7deg)"
    },
    bottom: {
      top: "0",
      left: "50%",
      borderRadius: RAW_cssValue("5px 0 0"),
      transform: "translate(-50%, -50%) rotate(45deg)  skew(7deg, 7deg)"
    },
    left: {
      top: "50%",
      right: "0",
      borderRadius: RAW_cssValue("0 5px 0 0"),
      transform: "translate(50%, -50%) rotate(45deg)  skew(-7deg, -7deg) scale(.75)"
    },
    right: {
      top: "50%",
      left: "0",
      borderRadius: RAW_cssValue("0 0 0 5px"),
      transform: "translate(-50%, -50%) rotate(45deg)  skew(-7deg, -7deg) scale(.75)"
    }
  };
  return _jsx(AnimationWrapper, {
    type: "bounceAnimation",
    animate: animate,
    isVisible: isOpen,
    children: _jsxs("div", {
      role: "tooltip",
      sx: {
        minWidth: "100px",
        position: "relative",
        backgroundColor: color,
        color: parseInt(weight) <= 40 ? "dt_taro60" : "white",
        borderRadius: RAW_cssValue("18px"),
        padding: "dt_s",
        paddingRight: onDismiss ? RAW_cssValue("".concat(12 + 12 + 15, "px")) : null,
        maxWidth: maxWidth || null,
        ":after": _objectSpread(_objectSpread({}, triangleStyle), placementStyles[placement])
      },
      children: [onDismiss && _jsx(CloseButton, {
        onClick: onDismiss
      }), _jsx("div", {
        children: children
      })]
    })
  });
};